<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
        <a [routerLink]="['home','dashboard']" class="app-logo">
            <div class="app-logo-small h-2rem" >
                <img  [src]="logoImage + (layoutService.config().colorScheme === 'light' ? 'dark' : 'light') + imageExt">
            </div>
            <div class="app-logo-normal">
                <img style="width: 80%; height: 80%;" [src]="logoImage + (layoutService.config().colorScheme === 'light' ? 'dark' : 'light') + imageExt">
                <!-- <img  class="h-2rem ml-3" [src]="'assets/images/appname-'+ (layoutService.config().colorScheme === 'light' ? 'dark' : 'light') + '.png'"/> -->
            </div>
        </a>
        <button class="layout-sidebar-anchor p-link z-2 " type="button" (click)="anchor()"></button>
    </div>
 

    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>